import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7cf91dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cache",
  ref: "mediaRef"
}
const _hoisted_2 = { class: "cache_top" }
const _hoisted_3 = { class: "cache_top_left" }
const _hoisted_4 = { class: "cache_operate" }
const _hoisted_5 = { class: "cache_operate_right" }
const _hoisted_6 = {
  key: 2,
  class: "liveList"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item_box" }
const _hoisted_9 = { class: "live_choice_true" }
const _hoisted_10 = { class: "live_img" }
const _hoisted_11 = { class: "live_img_position" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "live_img_tips" }
const _hoisted_15 = { class: "live_right" }
const _hoisted_16 = { class: "live_time" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 6px"} }, "辨", -1))
const _hoisted_18 = { class: "live_down" }
const _hoisted_19 = { class: "live_title" }
const _hoisted_20 = { class: "live_title_text" }
const _hoisted_21 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around","position":"relative"}
}
const _hoisted_22 = {
  ref: "videoRef",
  id: "videojs-player",
  controls: "",
  class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_a_statistic_countdown = _resolveComponent("a-statistic-countdown")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_c_del_modal = _resolveComponent("c-del-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_range_picker, {
          ranges: {
            今天: [_ctx.moment().startOf('day'), _ctx.moment().endOf('day')],
            最近一周: [_ctx.moment().startOf('day').subtract(1, 'weeks'), _ctx.moment()],
            最近一月: [_ctx.moment().startOf('day').subtract(1, 'months'), _ctx.moment()],
            最近三月: [_ctx.moment().startOf('day').subtract(3, 'months'), _ctx.moment()],
          },
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          onChange: _ctx.getVideoList,
          value: _ctx.queryForm.liveDate,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryForm.liveDate) = $event)),
          class: "mod_range_picker cache_top_left_picker"
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["ranges", "onChange", "value"]),
        _createVNode(_component_a_input_search, {
          value: _ctx.queryForm.keywords,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryForm.keywords) = $event)),
          placeholder: "请输入关键字",
          "enter-button": "",
          class: "mod_range_picker_search",
          onSearch: _ctx.getVideoList
        }, null, 8, ["value", "onSearch"]),
        _createVNode(_component_a_button, {
          class: "top_left_move mod_btn mod_btn_primary",
          onClick: _ctx.moveVideo,
          disabled: !_ctx.deleteSelect
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 移动至视频库 ")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_checkbox, {
            class: "checkbox",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getOperation(0))),
            checked: _ctx.choice,
            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.choice) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("选择")
            ]),
            _: 1
          }, 8, ["checked"]),
          _createVNode(_component_a_checkbox, {
            class: "checkbox",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getOperation(1))),
            checked: _ctx.choice_all,
            "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.choice_all) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("全选")
            ]),
            _: 1
          }, 8, ["checked"]),
          _createVNode(_component_a_button, {
            type: "link",
            danger: "",
            disabled: !_ctx.deleteSelect,
            onClick: _ctx.deleteLive
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_svg_icon, {
                class: "mod_btn_icon",
                "icon-class": "del"
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 删除 ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _createVNode(_component_a_alert, {
      type: "warning",
      class: "cache_tips",
      message: "直播缓存有效时间为14天，在14天后依次删除，请您及时将重要的直播缓存移至视频库。",
      banner: "",
      closable: ""
    }),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
      : (_ctx.liveData.length == 0)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 1,
            class: "empty_wrap",
            image: _ctx.emptyDataSec,
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_a_row, {
              class: "liveList_row",
              gutter: [16, 16]
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.live, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: _ctx.span,
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["live", [
              _ctx.choice || _ctx.choice_all ? 'live_choice' : '',
              (_ctx.choice || _ctx.choice_all) && _ctx.liveData[index].choice ? 'live_choices' : '',
            ]]),
                        onClick: ($event: any) => (_ctx.getLive(Number(index)))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_CheckOutlined, { class: "icon" })
                          ], 512), [
                            [_vShow, _ctx.choice || _ctx.choice_all]
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: item.cover_url
                              }, null, 8, _hoisted_12),
                              _createElementVNode("div", {
                                class: "live_img_play",
                                onClick: ($event: any) => (_ctx.videoPlay(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  class: "live_img_playSvg",
                                  "icon-class": "play"
                                })
                              ], 8, _hoisted_13)
                            ]),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.duration), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, "创建时间：" + _toDisplayString(item.updated_at), 1),
                            _createElementVNode("div", null, [
                              _createTextVNode("分"),
                              _hoisted_17,
                              _createTextVNode("率：" + _toDisplayString(item.resolution), 1)
                            ]),
                            _createElementVNode("div", null, "文件大小：" + _toDisplayString(item.size), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createTextVNode(" 删除倒计时： "),
                              _createVNode(_component_a_statistic_countdown, {
                                class: "community_statistic",
                                value: item.count_down,
                                format: "D 天 H 时 m 分",
                                getContainer: () => _ctx.mediaRef
                              }, null, 8, ["value", "getContainer"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1)
                        ])
                      ], 10, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["span"]))
                }), 128))
              ]),
              _: 1
            })
          ])),
    (_ctx.liveData.length !== 0)
      ? (_openBlock(), _createBlock(_component_a_pagination, {
          key: 3,
          class: "cache_pagination",
          "show-quick-jumper": "",
          "show-size-changer": "",
          "show-less-items": "",
          current: _ctx.pageConfig.current,
          "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageConfig.current) = $event)),
          "page-size": _ctx.pageConfig.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageConfig.pageSize) = $event)),
          total: _ctx.pageConfig.totalSize,
          pageSizeOptions: _ctx.pageConfig.options,
          onChange: _ctx.getVideoList,
          onShowSizeChange: _ctx.getVideoList
        }, null, 8, ["current", "page-size", "total", "pageSizeOptions", "onChange", "onShowSizeChange"]))
      : _createCommentVNode("", true),
    _createVNode(_component_c_del_modal, {
      visible: _ctx.visible,
      centered: "",
      close: _ctx.openDelModal,
      ok: _ctx.removeLiveData
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将删除该文件，是否继续？")
      ]),
      _: 1
    }, 8, ["visible", "close", "ok"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modal2Visible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modal2Visible) = $event)),
      centered: "",
      footer: null,
      zIndex: 2000,
      width: 1040,
      closable: false,
      onCancel: _ctx.modal2cancel
    }, {
      default: _withCtx(() => [
        (_ctx.playStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("video", _hoisted_22, null, 512),
              _createElementVNode("div", {
                style: {"position":"absolute","top":"-20px","right":"-14px","cursor":"pointer"},
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.modal2cancel && _ctx.modal2cancel(...args)))
              }, "✖")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 512))
}